module.exports = __webpack_public_path__ + "static/media/aroldo-header-icon.ed0b8773.svg";